/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import { Facet, Product, ProductView } from './fragments.js'

const PRODUCT_SEARCH_QUERY = /* GraphQL */ `
    query productSearch(
        $phrase: String!
        $pageSize: Int
        $currentPage: Int = 1
        $filter: [SearchClauseInput!]
        $sort: [ProductSearchSortInput!]
        $context: QueryContextInput
    ) {
        productSearch(
            phrase: $phrase
            page_size: $pageSize
            current_page: $currentPage
            filter: $filter
            sort: $sort
            context: $context
        ) {
            total_count
            items {
                ...Product
                ...ProductView
            }
            facets {
                ...Facet
            }
            page_info {
                current_page
                page_size
                total_pages
            }
        }
        attributeMetadata {
            sortable {
                label
                attribute
                numeric
            }
        }
    }
    ${Product}
    ${ProductView}
    ${Facet}
`

const QUICK_SEARCH_QUERY = /* GraphQL */ `
    query quickSearch(
        $phrase: String!
        $pageSize: Int = 20
        $currentPage: Int = 1
        $filter: [SearchClauseInput!]
        $sort: [ProductSearchSortInput!]
        $context: QueryContextInput
    ) {
        productSearch(
            phrase: $phrase
            page_size: $pageSize
            current_page: $currentPage
            filter: $filter
            sort: $sort
            context: $context
        ) {
            suggestions
            items {
                ...Product
                ...ProductView
            }
            facets {
                ...Facet
            }
            page_info {
                current_page
                page_size
                total_pages
            }
        }
    }
    ${Product}
    ${ProductView}
    ${Facet}
`

export {
    PRODUCT_SEARCH_QUERY,
    QUICK_SEARCH_QUERY
}
